import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * RunningState: spinner card for work in progress (e.g. title analysis).
 * Announced politely to assistive tech via role="status".
 * Light theme only.
 */
export interface RunningStateProps {
  title: string;
  description?: React.ReactNode;
  className?: string;
}

export const RunningState: React.FC<RunningStateProps> = ({
  title,
  description,
  className = '',
}) => (
  <div
    role="status"
    className={`flex flex-col items-center gap-2 rounded-xl border border-gray-200 bg-white px-6 py-10 text-center ${className}`.trim()}
  >
    <Loader2
      size={28}
      strokeWidth={2}
      className="animate-spin text-[#834DFB]"
      aria-hidden="true"
    />
    <h3 className="text-base font-bold text-gray-900">{title}</h3>
    {description ? <p className="max-w-md text-sm text-gray-600">{description}</p> : null}
  </div>
);

export default RunningState;
